import React, { useEffect } from 'react';
import { App, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setError } from '../redux/slice';
import ErrorContainer from '../modules/error/container';

const { Text } = Typography;

const Description = ({ errors }) => (
  <div className="notification-description">
    {errors?.map((msg, index) => {
      return (
        <p key={index}>
          <Text type="danger">{msg}</Text>
        </p>
      );
    })}
  </div>
);

const AppError = () => {
  const dispatch = useDispatch();
  const error = useSelector((state) => state.common.error);
  const { notification } = App.useApp();

  useEffect(() => {
    const { message, errors } = error || {};
    if (!message) return;

    const handleClearError = () => dispatch(setError({}));

    if (Array.isArray(message)) {
      message.forEach((msg) => {
        notification.error({
          message: msg,
          style: { top: '52px' },
          description: errors && <Description errors={errors} />,
          placement: 'topRight',
          onClose: handleClearError,
        });
      });
    } else {
      notification.error({
        message: message,
        style: { top: '52px' },
        description: errors && <Description errors={errors} />,
        placement: 'topRight',
        onClose: handleClearError,
      });
    }
  }, [error, notification, dispatch]);

  return null;
};

export default ErrorContainer(AppError);
